import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import { db, auth } from "../firebase";

export default class GoalsModel {
  static db_name = "goals";
  static goalsCollection = collection(db, this.db_name);

  static async add(goal, duration, index, goalType) {
    try {
      await addDoc(collection(db, this.db_name), {
        goal,
        duration,
        days: [],
        index,
        uid: auth.currentUser?.uid,
        type: goalType,
      });
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }

  static async delete(id) {
    await deleteDoc(doc(db, this.db_name, id));
  }

  static async update(goal, updated) {
    const ref = doc(db, this.db_name, goal.id ?? undefined);
    setDoc(ref, { ...goal, ...updated });
  }
}

export const goalTypes = {
  morning: {
    color: "orange",
    label: "Morning",
    emoji: "🌅",
  },
  fitness: {
    color: "green",
    label: "Fitness",
    emoji: "💪",
  },
  creative: {
    color: "cyan",
    label: "Creative/Art",
    emoji: "🎨",
  },
  learning: {
    color: "pink",
    label: "Learning",
    emoji: "📚",
  },
  evening: {
    color: "purple",
    label: "Evening",
    emoji: "🌙",
  },
  weekly: {
    color: "blue",
    label: "Weekly",
    emoji: "🗓️",
  },
  other: {
    color: "grey",
    label: "Other",
    emoji: "❓",
  },
};
